import ActivityIcon from './ActivityIcon'
import AwardsIcon from './AwardsIcon'
import BonusIcon from './BonusIcon'
import CanteenIcon from './CanteenIcon'
import HealthcareIcon from './HealthcareIcon'
import KindergartenIcon from './KindergartenIcon'
import LaptopIcon from './LaptopIcon'
import LibraryIcon from './LibraryIcon'
import MoreIcon from './MoreIcon'
import PaidLeaveIcon from './PaidLeaveIcon'
import PhoneIcon from './PhoneIcon'
import TrainingIcon from './TrainingIcon'
import TransportationIcon from './TransportationIcon'
import TravelIcon from './TravelIcon'
import VoucherIcon from './VoucherIcon'
import PhysicsIcon from './Physics'
import WorkingHourIcon from './WorkingHourIcon'
import WorkingDayIcon from './WorkingDayIcon'
import WorkingTypeIcon from './WorkingTypeIcon'

const Benefit = {
    ActivityIcon,
    AwardsIcon,
    BonusIcon,
    CanteenIcon,
    HealthcareIcon,
    KindergartenIcon,
    LaptopIcon,
    LibraryIcon,
    MoreIcon,
    PaidLeaveIcon,
    PhoneIcon,
    TrainingIcon,
    TransportationIcon,
    TravelIcon,
    VoucherIcon,
    PhysicsIcon,
    WorkingDayIcon,
    WorkingHourIcon,
    WorkingTypeIcon
}

export default Benefit
